import React, { useCallback, useState } from 'react'
import cn from 'classnames'
import { Dropdown } from 'util/ui'
import Sidebar from 'shared/components/ui/Sidebar'
import SettingsSidebarActions from './Actions'
import styles from './styles.less'

// const THIRTY_SECONDS = 30 * 1000
const FIVE_MINUTES = 5 * 60 * 1000
const TEN_MINUTES = 10 * 60 * 1000
const FIFTEEN_MINUTES = 15 * 60 * 1000
const THIRTY_MINUTES = 30 * 60 * 1000
const FORTYFIVE_MINUTES = 45 * 60 * 1000
const ONE_HOUR = 1 * 60 * 60 * 1000
const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000
const FOURTEEN_DAYS = 14 * 24 * 60 * 60 * 1000

const autoAwayOptions = [
  // Useful for debugging
  // {
  //   text: '30 seconds',
  //   key: '30 Seconds',
  //   value: THIRTY_SECONDS,
  // },
  {
    text: '5 Minutes',
    key: '5-minutes',
    value: FIVE_MINUTES,
  },
  {
    text: '10 Minutes',
    key: '10-minutes',
    value: TEN_MINUTES,
  },
  {
    text: '15 Minutes',
    key: '15-minutes',
    value: FIFTEEN_MINUTES,
  },
  {
    text: '30 Minutes',
    key: '30-minutes',
    value: THIRTY_MINUTES,
  },
  {
    text: '45 Minutes',
    key: '45-minutes',
    value: FORTYFIVE_MINUTES,
  },
  {
    text: 'Never',
    key: 'never',
    value: SEVEN_DAYS, // 7 days
  },
]

const autoOfflineOptions = [
  // Usefull for debugging
  // {
  //   text: '30 Seconds',
  //   key: '30-seconds',
  //   value: THIRTY_SECONDS,
  // },
  {
    text: '10 Minutes',
    key: '10-minutes',
    value: TEN_MINUTES,
  },
  {
    text: '15 Minutes',
    key: '15-minutes',
    value: FIFTEEN_MINUTES,
  },
  {
    text: '30 Minutes',
    key: '30-minutes',
    value: THIRTY_MINUTES,
  },
  {
    text: '45 Minutes',
    key: '45-minutes',
    value: FORTYFIVE_MINUTES,
  },
  {
    text: '1 Hour',
    key: '1-hour',
    value: ONE_HOUR,
  },
  {
    text: 'Never',
    key: 'never',
    value: FOURTEEN_DAYS, // 7 days
  },
]

function ensureAutoOfflineIsGreater(autoAway, autoOffline) {
  if (autoAway === SEVEN_DAYS) {
    return FOURTEEN_DAYS
  }
  return autoOffline
}

export default function PresenceSettingsSidebar({
  open,
  onClose,
  onSave,
  autoAwaySetting = FIVE_MINUTES,
  autoOfflineSetting = TEN_MINUTES,
}) {
  const [settings, updateSettings] = useState({
    autoAwaySetting,
    autoOfflineSetting,
  })

  const handleOnSaveClick = useCallback(
    () => {
      if (onSave) onSave(settings)
    },
    [onSave, settings]
  )

  const handleOnChange = useCallback(
    (_, { id, value }) => {
      updateSettings({
        ...settings,
        autoAwaySetting:
          id === 'autoAwaySetting' ? value : settings.autoAwaySetting,
        autoOfflineSetting: ensureAutoOfflineIsGreater(
          id === 'autoAwaySetting' ? value : settings.autoAwaySetting,
          id === 'autoOfflineSetting' ? value : settings.autoOfflineSetting
        ),
      })
    },
    [settings, updateSettings]
  )

  const handleOnClose = useCallback(
    () => {
      updateSettings({
        autoAwaySetting,
        autoOfflineSetting,
      })
      if (onClose) onClose()
    },
    [onClose, updateSettings, autoAwaySetting, autoOfflineSetting]
  )

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <Sidebar
      headerChildren="Auto-away settings"
      footerChildren={
        <SettingsSidebarActions
          onClose={handleOnClose}
          onSave={handleOnSaveClick}
        />
      }
      open={open}
      onClose={onClose}
      narrow
      className={cn(styles.presenceSettingsSidebar, 'presenceSettingsSidebar')}
    >
      <div className="container">
        <div className="heading">Auto-away</div>
        <div className="description">
          Automatically set my presence as away after a period of inactivity.
        </div>
        <Dropdown
          id="autoAwaySetting"
          options={autoAwayOptions}
          value={settings.autoAwaySetting}
          selection
          onChange={handleOnChange}
        />
        <div className="heading">Automatic offline</div>
        <div className="description">
          Automatically set my presence as offline after being away for a
          period.
        </div>
        <Dropdown
          id="autoOfflineSetting"
          options={autoOfflineOptions}
          value={settings.autoOfflineSetting}
          selection
          onChange={handleOnChange}
        />
      </div>
    </Sidebar>
  )
}
